import { defineComponent as _defineComponent } from 'vue'
import { Location } from '@/models/location';
import GenericKeyCopyModal from '@/components/GenericKeyCopyModal.vue';
import { locationsService } from '@/services/locations.service';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectionStringModal',
  props: {
    location: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  location: Location;
};





const loading = ref(false);
const connectionString = ref('');

onMounted(async () => {
  loading.value = true;
  try {
    const apiKey = await locationsService.getApiKey(props.location.id);
    connectionString.value = [
      `Endpoint=${window.location.host}`,
      `LocationId=${props.location.id}`,
      `ApiKey=${apiKey}`,
    ].join(';');
  } catch (e) {
    emit('close');
  } finally {
    loading.value = false;
  }
});

return { __sfc: true,props, emit, loading, connectionString, GenericKeyCopyModal }
}

})